import { Link } from "react-router-dom";
import { navItems, siteName } from "@/mocks/anime";

export default function AnimeFooter() {
  return (
    <footer className="mt-auto bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-graduation-cap-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg text-foreground-900">{siteName}</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              专注《秘密教学动漫》的剧情解读、分集介绍、角色图鉴与结局解析。汇总每一话的伏笔与彩蛋，帮你快速理清全篇脉络，不用到处翻找。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((item) => (
                <li key={item.key}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-900">热门栏目</h3>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/episodes" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">分集剧情速览</Link></li>
              <li><Link to="/characters" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">角色图鉴大全</Link></li>
              <li><Link to="/ending" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">结局与彩蛋解析</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">关于本站</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteName} · 本站内容仅供剧情讨论与参考
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <a href="#contact" aria-label="联系" className="hover:text-primary-600 cursor-pointer"><i className="ri-mail-line text-base"></i></a>
            <a href="#contact" aria-label="留言" className="hover:text-primary-600 cursor-pointer"><i className="ri-chat-3-line text-base"></i></a>
            <a href="#contact" aria-label="返回顶部" className="hover:text-primary-600 cursor-pointer"><i className="ri-arrow-up-line text-base"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}